<template>
<div>
  <div v-if="item.street">
    <span>
      <icon name="location-arrow" />
      <b>{{item.city}} {{item.street}} {{item.number}}</b>
    </span>
    <br>
    <abbr>{{item.voivodeship}}, {{item.county}}, {{item.commune}}</abbr>
  </div>
  <div v-else>
    <span>
      <icon name="city" />
      <b>{{item.city}} {{item.number}}</b>
      </span>
    <br>
    <abbr>{{item.voivodeship}}, {{item.county}}, {{item.commune}}</abbr>
  </div>
</div>

</template>

<script>
export default {
  props: {
    item: Object,
  }
}
</script>

